import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Responsiveness = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="m4.828 2.276-.942-.943L2 3.22l.943.943 1.885-1.886Zm4.505-.943H6.667v1.334h.666v.708a5.334 5.334 0 0 0-.108 10.57l.193-1.32A4.001 4.001 0 1 1 10 12.132V10H8.667v4h4.666v-1.333H11.53a5.334 5.334 0 0 0-2.862-9.292v-.708h.666V1.333Z"
      fill="currentColor"
    />
    <path
      d="M10.633 6.943 9.69 6 7.333 8.357l.943.943 2.357-2.357Zm2.586-2.781.943-.943-1.886-1.886-.943.943 1.886 1.886Z"
      fill="currentColor"
    />
  </Icon>
));

export default Responsiveness;
